"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = _interopRequireDefault(require("./styles"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LIStyle = _styles["default"].LIStyle,
    PopupContent = _styles["default"].PopupContent,
    PopupLi = _styles["default"].PopupLi,
    PopupContainer = _styles["default"].PopupContainer,
    SelectULStyle = _styles["default"].SelectULStyle,
    SelectLIStyle = _styles["default"].SelectLIStyle,
    DropDownContent = _styles["default"].DropDownContent,
    DropDownLi = _styles["default"].DropDownLi,
    DropDownLiSelected = _styles["default"].DropDownLiSelected,
    DropDownItemsContainer = _styles["default"].DropDownItemsContainer,
    MultiSectionHeader = _styles["default"].MultiSectionHeader,
    LabelDiv = _styles["default"].LabelDiv,
    SelectContainer = _styles["default"].SelectContainer;

var SelectField = function SelectField(props) {
  var selectOptions = props.selectOptions,
      placeholder = props.placeholder,
      background = props.background,
      width = props.width,
      radius = props.radius,
      shadow = props.shadow,
      itemPadding = props.itemPadding,
      fontSize = props.fontSize,
      helperText = props.helperText,
      label = props.label,
      optional = props.optional,
      optionalTag = props.optionalTag,
      multiSelectOptions = props.multiSelectOptions;
  var selectedValue, valueDisplay;

  if (!_lodash["default"].isNil(props, 'value')) {
    if (_lodash["default"].isObject(props.value)) {
      selectedValue = props.value;
    } else if (_lodash["default"].isString(props.value)) {
      selectedValue = props.value;
    }
  } else {
    selectedValue = placeholder;
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOptions = _useState2[0],
      setShowOptions = _useState2[1],
      switchShowOptions = function switchShowOptions(value) {
    if (!_lodash["default"].isNil(value)) {
      if (value === true) {
        document.addEventListener('click', pageClick, false);
      } else if (value === false) {
        document.removeEventListener('click', pageClick, false);
      }

      setShowOptions(value);
    }
  },
      _useState3 = (0, _react.useState)(selectedValue),
      _useState4 = _slicedToArray(_useState3, 2),
      selected = _useState4[0],
      setValue = _useState4[1],
      changeValue = function changeValue(e, selected) {
    switchShowOptions(false);
    setValue(selected);
    props.onChange(selected);
  };

  function pageClick(e, v) {
    switchShowOptions(false);
  }

  (0, _react.useEffect)(function () {
    if (props.value !== selected) setValue(props.value);
  }, [props.value]);

  var DropDownOption = function DropDownOption(_ref) {
    var option = _ref.option,
        selected = _ref.selected,
        index = _ref.index;

    if (_lodash["default"].isEqual(selected, option)) {
      return /*#__PURE__*/_react["default"].createElement(DropDownLiSelected, {
        key: "value".concat(index),
        className: "selected",
        onClick: function onClick(e) {
          return changeValue(e, option);
        }
      }, _lodash["default"].isObject(option) && option[props.name], _lodash["default"].isString(option) && option);
    } else {
      return /*#__PURE__*/_react["default"].createElement(DropDownLi, {
        key: "value".concat(index),
        onClick: function onClick(e) {
          return changeValue(e, option);
        }
      }, _lodash["default"].isObject(option) && option[props.name], _lodash["default"].isString(option) && option);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(SelectContainer, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "label-container"
  }, label ? label : '', optionalTag ? /*#__PURE__*/_react["default"].createElement("span", null, "- Optional") : ''), helperText && /*#__PURE__*/_react["default"].createElement("p", {
    className: "helper-text"
  }, helperText), props.mode === 'popup' && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(PopupContainer, {
    onClick: function onClick() {
      switchShowOptions(!showOptions);
    }
  }, props.children, /*#__PURE__*/_react["default"].createElement(PopupContent, {
    width: width,
    background: background,
    radius: radius,
    shadow: shadow
  }, showOptions && _lodash["default"].map(selectOptions, function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(PopupLi, {
      itemPadding: itemPadding,
      fontSize: fontSize,
      key: "value".concat(index),
      onClick: function onClick(e) {
        return changeValue(e, option);
      }
    }, _lodash["default"].isObject(option) && option[props.name], _lodash["default"].isString(option) && option);
  })))), !props.mode && /*#__PURE__*/_react["default"].createElement(SelectULStyle, {
    className: "selectInput"
  }, /*#__PURE__*/_react["default"].createElement(DropDownContent, null, /*#__PURE__*/_react["default"].createElement(SelectLIStyle, {
    onClick: function onClick() {
      return switchShowOptions(!showOptions);
    }
  }, /*#__PURE__*/_react["default"].createElement(LabelDiv, null, _lodash["default"].isObject(selected) && /*#__PURE__*/_react["default"].createElement("div", null, selected[props.name]), _lodash["default"].isString(selected) && /*#__PURE__*/_react["default"].createElement("div", null, selected), _lodash["default"].isNil(selected) && /*#__PURE__*/_react["default"].createElement("div", null, props.placeholder), /*#__PURE__*/_react["default"].createElement("i", {
    className: "fa fa-chevron-down"
  }))), showOptions && selectOptions && /*#__PURE__*/_react["default"].createElement(DropDownItemsContainer, null, _lodash["default"].map(selectOptions, function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(DropDownOption, {
      option: option,
      index: index,
      selected: selected
    });
  })), showOptions && multiSelectOptions && /*#__PURE__*/_react["default"].createElement(DropDownItemsContainer, null, multiSelectOptions.map(function (section, index) {
    if (section.name === 'default') return /*#__PURE__*/_react["default"].createElement(DropDownOption, {
      option: section.options[0],
      index: index,
      selected: selected
    });else {
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(MultiSectionHeader, null, section.name), section.options.map(function (option, index) {
        return /*#__PURE__*/_react["default"].createElement(DropDownOption, {
          option: option,
          index: index,
          selected: selected
        });
      }));
    }
  }))))));
};

SelectField.defaultProps = {
  id: 'id',
  name: 'name',
  placeholder: 'Select an option...'
};
SelectField.propTypes = {
  label: _propTypes["default"].string,
  height: _propTypes["default"].string,
  width: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  optional: _propTypes["default"].bool,
  optionalTag: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  helperText: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  iconLeft: _propTypes["default"].string,
  onIconLeftClick: _propTypes["default"].func,
  iconRight: _propTypes["default"].string,
  onIconRightClick: _propTypes["default"].func,
  rounded: _propTypes["default"].bool,
  onError: _propTypes["default"].func,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  name: _propTypes["default"].string,
  background: _propTypes["default"].string,
  shadow: _propTypes["default"].string,
  itemPadding: _propTypes["default"].string,
  fontSize: _propTypes["default"].string,
  selectOptions: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].object)]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string.isRequired, _propTypes["default"].object.isRequired])
};
var _default = SelectField;
exports["default"] = _default;